import { AccountView } from './account-view';
import { Environment } from '../environment/environment';
import { PopupIds } from '../constants/PopupIds';
import { RealCurrentUser } from '../general/modules/user/realCurrentUser';
import { CurrentUser } from '../general/modules/user/currentUser';
import { Tethers } from '../accounts/tethers';
import ConsentState from '../marketing/ConsentState';
import { requestAccountWindow } from './account-window-api';
import { ErrorSmallPopup } from '../popups/errorSmallPopup';
import { Localization } from '../localization/localization';
import { getOpenAccountButtons } from './open-account-buttons';

export function handleGetAccountWindowResponse(view: string) {
    const $accountManagement = $('#account_management');
    const $openAccountButtons = getOpenAccountButtons();

    AccountView.removeBodyWrapper();
    AccountView.removeHeader();
    AccountView.hideAccountLoadingState();
    $accountManagement.append(view);

    if (Environment.isSocial()) {
        const avatar = AccountView.getAvatarElement();
        const user = window.app.user;

        if (avatar.length) {
            if (user?.photo && user?.photo !== '') {
                AccountView.setAccountAvatar(user.photo);
            } else {
                if (!avatar[0].complete) {
                    AccountView.hideAccountAvatar();
                }
            }
        }

        if (user.full_name && user.full_name.trim() !== '') {
            AccountView.setUserName(user.full_name);
        }
    }

    $openAccountButtons.on('click', () => {
        window.app.game_popup_close();
        window.app.game_popup(PopupIds.ACCOUNT_MANAGEMENT);
    });

    AccountView.initializeCustomScrollbars();
}
export async function loadAccountWindow() {
    window.app.game_popup_close();
    window.app.game_popup(PopupIds.ACCOUNT_MANAGEMENT);
    AccountView.showAccountLoadingState();

    const suid = RealCurrentUser.getInstance()
        .getSuid()
        .toString();

    try {
        const token = CurrentUser.getInstance().getAuthToken();
        const linkedAccountsInfo = await Tethers.getLinkedAccountsInfo(suid, token);

        if ('error' in linkedAccountsInfo) {
            AccountView.closeAccountWindow();
            showLoadAccountWindowErrorPopup(Localization._n('common_error'));
            return;
        }

        const consentState = await (new ConsentState()).getConsentState();

        if ('error' in consentState) {
            AccountView.closeAccountWindow();
            showLoadAccountWindowErrorPopup(Localization._n('common_error'));
            return;
        }

        const accountView = await requestAccountWindow(
            suid,
            linkedAccountsInfo,
            consentState
        );
        handleGetAccountWindowResponse(accountView);
    } catch (error) {
        showLoadAccountWindowErrorPopup(Localization._n('common_error'));
        window.Sentry.captureException(error);
    }
}


function showLoadAccountWindowErrorPopup(message: string): void {
    const errorSmallPopup = ErrorSmallPopup.getInstance();
    errorSmallPopup.setMessage(message);
    errorSmallPopup.setButtonText(Localization._n('ecommpay.button_to_retry'));
    errorSmallPopup.show();
    errorSmallPopup.setCallback(() => {
        AccountView.closeAccountWindow();
        errorSmallPopup.hide();
    });
}
